import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.token;
  const publicAuth =
    req.url.includes('/api/v1/auth/login') || req.url.includes('/api/v1/auth/refresh');
  const authReq =
    token && !publicAuth ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !publicAuth) {
        auth.logout();
      }
      return throwError(() => err);
    }),
  );
};
